import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export function useMobile() {
  const breakpoints = useBreakpoints(breakpointsTailwind)
  const isMobile = breakpoints.smaller('lg')

  return { isMobile }
}
